import { useLocation, Navigate } from "react-router-dom";
import useGlobalContext from "../contexts-hooks/hooks/useGlobalContext";

const PrivateRoute = ({ element, requiredRoleType }) => {
  const { state } = useGlobalContext();

  const roleType = state.user?.role;
  const location = useLocation();
  if(roleType){
    if (!roleType || !requiredRoleType.includes(roleType)) {
      return <Navigate to="/unauthorized" state={{ from: location }} replace />;
    }
  }
  return element;
};

export default PrivateRoute;
